<div
  class="form-group"
  [ngClass]="{
    'has-error has-danger':
      ngControl.touched && !ngControl.valid && !ngControl.disabled,
    'has-success': ngControl.touched && ngControl.valid
  }"
>
  <label
    class="form-control-label"
    [ngClass]="{ 'form-control-label-required': hasRequiredValidator() }"
    [for]="identifier"
    >{{ labelText }}</label
  >
  <input
    [id]="identifier"
    [name]="name"
    class="form-control"
    [ngClass]="
      hasRequiredError() || hasPhoneError()
        ? 'is-invalid'
        : touched
        ? 'is-valid'
        : ''
    "
    type="text"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    #control="ngModel"
    [required]="required == 'true' || required == '' ? '' : undefined"
    (blur)="onTouched()"
    [readonly]="readonly"
    [disabled]="disabled"
    [attr.aria-required]="isRequired"
    [attr.aria-describedby]="isShowErrors ? identifier + '-feedbacks' : null"
  />
  <small
    [id]="identifier + 'Help'"
    *ngIf="helpText"
    class="form-text text-muted"
  >
    {{ helpText }}</small
  >

  <ng-container *ngTemplateOutlet="feedback"> </ng-container>
</div>

<ng-template #feedback>
  <ng-container *ngIf="isShowErrors">
    <div [id]="identifier + '-feedbacks'" class="invalid-feedback" role="alert">
      <div
        *ngFor="let error of errors; trackBy: trackByMessageKey"
        [innerText]="
          key + '.' + error.messageKey | translate : error.messageArgs
        "
      ></div>
    </div>
  </ng-container>
</ng-template>
